/**
 * Get current viewer country code
 * @return {String} The viewer's country code
 */

export function getCountryCode() {

  // Get the 'cloudfront-viewer-country' response header value that is returned from AWS (must be added in Cloudfront responses beforehand)
  const req = new XMLHttpRequest()
  req.open('GET', document.location, false)
  req.send(null)
  let viewerCountryHeader = req.getResponseHeader('cloudfront-viewer-country')

  // Fallback to 'Canada' if the Cloudfront Header is null or not available
  if (!viewerCountryHeader || viewerCountryHeader === null) {
    viewerCountryHeader = 'CA'
  }

  // Dev/Staging testing tool
  if (process.env.GATSBY_ENV === 'dev' || process.env.GATSBY_ENV === 'stg') {
    const storedValue = localStorage.getItem('BhvrDevToolsCountry')
    if (storedValue && storedValue !== null) {
      viewerCountryHeader = storedValue
    }
  }

  // Return the viewer's country code (CA, US, etc.)
  return viewerCountryHeader
}
